import React from 'react';

function Fieldset({
  children,
  title,
  disabled,
  legendStyle = 'h3',
  hiddenLegend,
}) {
  return (
    <fieldset className="u-margin-bottom-none" disabled={disabled}>
      <legend
        className={`${legendStyle} u-margin-bottom-base ${
          hiddenLegend && 'u-visually-hidden'
        }`}
      >
        {title}
      </legend>
      {children}
    </fieldset>
  );
}

export default Fieldset;
